/**
 * Picture descriptor for referencing images in backgrounds/layouts
 */
export class QPicDesc {
  constructor() {
    /** @type {string|null} */
    this.fDirectory = null;
    /** @type {string|null} */
    this.fFileName = null;
    /** @type {boolean|null} */
    this.fIsURL = null;
  }

  /**
   * @param {string} directory
   * @param {string} fileName
   * @returns {boolean}
   */
  Equal(directory, fileName) {
    if (directory != this.fDirectory) return false;
    if (fileName != this.fFileName) return false;

    return true;
  }
}
